import requestor from "shared/service/requestor";

export default class ArticleApi {
  all = (mode) => requestor.get("/article/all", { mode: mode });
  one = (id) => requestor.get("/article/one", { id: id });
  create = (mode) => requestor.post("/article/create", { mode: mode });
  save = (id, form) => requestor.post("/article/save", { id: id, Article: form });
  delete = (id) => requestor.get("/article/delete", { id: id });
}
